import { Accordion } from '@zendeskgarden/react-accordions';
import type { PropsAccordion } from "./interface";

export function GardenAccordion({ items }: PropsAccordion) {
  return (
    <Accordion
      level={4}
      isBare
    >
        <Accordion.Section>
          <div className="border border-gray-300 rounded-md">
          <Accordion.Header>
            <Accordion.Label>
              <p className='font-bold text-sm text-gray-700'>
                {items.title}
              </p>
              </Accordion.Label>
          </Accordion.Header>
          <Accordion.Panel style={{ padding: '0px'}}>{items.content}</Accordion.Panel>
          </div>
        </Accordion.Section>
    </Accordion>
  );
}
